import React from 'react';
import Icon from '../../UI/Icon/Icon';

// Styles & Assets
import styles from './ButtonsAddDelete.module.css';
import { MdDelete, MdAddBox } from 'react-icons/md';

// Hooks
import { useState } from 'react';

// Components
import Modal from '../../UI/Modal/Modal';
import DialogAddZone from '../DialogAddZone/DialogAddZone';
import DialogDeleteZone from '../DialogDeleteZone/DialogDeleteZone';

// Interfaces
import { Zone } from '../../../interfaces/Zone';

const ButtonsAddDelete: React.FC<{
    zoneID: Zone['id'] | undefined,
    addCallback: (zone: Zone) => void
    removeCallback: (zone: Zone['id']) => void
}> = ({ zoneID, addCallback, removeCallback }) => {

    const [showAddDialog, setShowAddDialog] = useState<boolean>(false);
    const [showDeleteDialog, setShowDeleteDialog] = useState<boolean>(false);

    return (
        <div className={styles.zonesButtons}>
            <button disabled={zoneID === undefined} onClick={() => setShowDeleteDialog(true)}>
                <Icon><MdDelete /></Icon>
            </button>
            <button onClick={() => setShowAddDialog(true)}>
                <Icon><MdAddBox /></Icon>
            </button>
            <Modal show={showAddDialog} setShowModal={setShowAddDialog}>
                <DialogAddZone
                    showModal={setShowAddDialog}
                    callback={addCallback}
                />
            </Modal>
            <Modal show={showDeleteDialog} setShowModal={setShowDeleteDialog}>
                <DialogDeleteZone
                    showModal={setShowDeleteDialog}
                    zoneID={zoneID}
                    callback={removeCallback}
                />
            </Modal>
        </div>
    );
};

export default ButtonsAddDelete;